<template>
  <!-- Grafico de estados -->
  <div
    class="completo"
    ref="todo"
  >
    <canvas
      :ref="myCanvas"
      @mousemove="updateInfoDivPosition"
      @mouseleave="hideInfoDiv"
    ></canvas>
    <canvas
      class="canvas-labels"
      ref="myCanvasLabels"
    >
    </canvas>

    <!-- Canvas para mostrar información -->
    <div
      class="info-div"
      ref="myCanvasInfo"
    >
      Información
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment-timezone";
// import mqtt from "mqtt/dist/mqtt";

export default {
  props: {
    input: Object,
    index: Number
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      canvasWidth: 10,
      canvasHeight: 10,

      dataList: [], // Lista que se llenará con los datos generados
      timeDifferenceInSeconds: 0,
      infoDivVisible: false,

      rectangles: [], // Almacena la información de cada rectángulo

      mqttVal: null,
    };
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage", "scadaDimensions"]),
    ...mapState("nodered", ["client"]),
    myCanvas(){
      return `myCanvas${this.index}`;
    },
    filtroAVigilar() {
      try {
        // console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        // console.log("El elegido es", a);
        return a.customized.data;
      } catch (error) {
        return [];
      }
    },

    filtroAsociado() {
      try {
        // console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        // console.log("El elegido es", a);
        return a.customized;
      } catch (error) {
        return {};
      }
    },

    filterType() {
      return this.input.customized.filterType;
    },

    topicMQTT() {
      return this.input.customized.mqtt;
    },

    idEjeX() {
      return this.input.customized.tipoEjeX;
    },
  },
  watch: {
    mqttVal() {
      // console.log("watch", this.mqttVal);
      this.drawLiveLegend();
    },
    filtroAVigilar() {
      // this.dataList = this.generateData(3);
      if (this.filtroAsociado && Object.keys(this.filtroAsociado).length > 0) {
        this.dataList = JSON.parse(JSON.stringify(this.filtroAVigilar));

        try {
          this.dataList.map((l) => {
            l.color = this.generarColor(l.value);
            return l;
          });
          // this.timeDifferenceInSeconds = this.calculateTimeDifference(this.dataList);
          this.timeDifferenceInSeconds = this.diferenciaEntreFechaHorasEnSegundos(
            this.filtroAsociado.valorFechas.inicio,
            this.filtroAsociado.valorFechas.fin
          );
          console.log("EN EL WATCH DE FILTRO A VIGILAR", this.timeDifferenceInSeconds);
          this.updateCanvasSize(); // Llama a la función para ajustar el tamaño y redibujar
        } catch (error) {
          console.log(error);
        }
      }
    },
    scadaDimensions: {
      handler() {
        this.updateCanvasSize();
      },
      deep: true,
    },
    "input.customized": {
      handler() {
        this.updateCanvasSize();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["getData"]),
    ...mapActions("nodered", ["doSubscribe", "destroyConnection", "doUnsubscribe"]),
    getRectangleAtPosition(x, y) {
      // Buscar el rectángulo en la posición del ratón
      return this.rectangles.find((rect) => {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
      });
    },
    getContrastingTextColor(backgroundColor) {
      // Convertir el color de fondo a RGB
      const color = backgroundColor.charAt(0) === "#" ? backgroundColor.substring(1, 7) : backgroundColor;
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);

      // Calcular la luminosidad relativa (formula estándar)
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

      // Si la luminosidad es alta, usar texto oscuro; si es baja, usar texto claro
      return luminance > 0.5 ? "#000000" : "#FFFFFF";
    },
    updateInfoDivPosition(event) {
      if (this.filtroAVigilar.length == 0) return;
      const infoDiv = this.$refs.myCanvasInfo;
      const canvas = this.$refs[this.myCanvas]

      if (!this.infoDivVisible) {
        infoDiv.style.display = "block";
        this.infoDivVisible = true;
      }

      const canvasRect = canvas.getBoundingClientRect();
      const x = event.clientX - canvasRect.left;
      const y = event.clientY - canvasRect.top;

      // Obtener el rectángulo en la posición del ratón
      const rectangle = this.getRectangleAtPosition(x, y);
      if (rectangle) {
        const backgroundColor = rectangle.color;
        const textColor = this.getContrastingTextColor(backgroundColor);

        infoDiv.innerHTML = `
          <div class="info-content"  style="text-align: center; color: ${textColor};">
          <span class="info-value">${moment(rectangle.fechaInicio).format("DD/MM/DD HH:mm:ss")} 
            - 
          ${moment(rectangle.fechaFin).format("DD/MM/DD HH:mm:ss")} 
          </span>
          [ <span class="info-value">${this.formatDuration(rectangle.diferenciaEnSegundos)}</span> ]
          </div>`;

        // Cambiar el fondo del div al color del rectángulo
        infoDiv.style.backgroundColor = rectangle.color;
      } else {
        infoDiv.innerHTML = "No info";
        infoDiv.style.backgroundColor = "white";
        infoDiv.style.color = "black";
      }
      infoDiv.style.border = "2px solid black";

      const windowWidth = window.innerWidth;
      const infoDivWidth = infoDiv.offsetWidth;
      const padding = 10; // Ajuste adicional para evitar solapamientos

      let leftPosition = event.clientX - canvasRect.left + padding;

      // Verificar si el div se sale de la pantalla por la derecha
      if (event.clientX + infoDivWidth + padding > windowWidth) {
        // Si es así, mover el div a la izquierda del ratón
        leftPosition = event.clientX - canvasRect.left - infoDivWidth - padding;
      }

      infoDiv.style.left = `${leftPosition}px`;
      infoDiv.style.top = `${y + padding}px`;
    },

    hideInfoDiv() {
      const infoDiv = this.$refs.myCanvasInfo;
      this.infoDivVisible = false;
      infoDiv.style.display = "none";
    },
    formatDuration(seconds) {
      const days = Math.floor(seconds / 86400); // 86400 segundos en un día
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;

      // Construir la cadena de salida
      let formattedTime = "";

      if (days > 0) {
        formattedTime += `${days}d ${hours}h ${minutes}m ${remainingSeconds}s`;
      } else if (hours > 0) {
        formattedTime += `${hours}h ${minutes}m ${remainingSeconds}s`;
      } else if (minutes > 0) {
        formattedTime += `${minutes}m ${remainingSeconds}s`;
      } else {
        formattedTime += `${remainingSeconds}s`;
      }
      return formattedTime;
    },

    generarTextoEstado(estado) {
      return estado;
    },
    generarColor(marcha) {
      const elemento = this.input.customized.estados.filter((es) => es.valor == marcha);
      // console.log("elemento.length", elemento.length);
      if (elemento.length == 1) {
        return elemento[0].color;
      } else return "black";
    },
    updateCanvasSize() {
      try {
        if (this.input && this.input.customized && this.scadaDimensions) {
          this.canvasWidth = (this.input.customized.width / 100) * this.scadaDimensions.width;
          this.canvasHeight = (this.input.customized.height / 100) * this.scadaDimensions.height;
          // Accede al canvas y ajusta el tamaño
          const canvas = this.$refs[this.myCanvas];
          canvas.width = this.canvasWidth;
          canvas.height = this.canvasHeight;

          //comprobar si hay filtro asociado
          if (this.filterType == "Filtros") {
            this.drawBox(); // Redibuja después de cambiar el tamaño
            this.drawLabels(); // Redibuja las etiquetas
          }
          //comporbar si hay un topic
          else if (this.filterType == "MQTT") {
            //comprobar si hay un topic
            if (this.topicMQTT != "") {
              //si el topic anterior es distinto al actual, desuscribirse del anterior
              // if (this.lastTopic !== "" && this.lastTopic != this.topicMQTT) {
              //   //desubscirbirse
              //   this.doUnsubscribe(this.lastTopic);
              // }
              // this.lastTopic = this.topicMQTT;
              this.doSubscribe(this.topicMQTT);
              this.drawLive();
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    diferenciaEntreFechaHorasEnSegundos(dateStrA, dateStrB) {
      // Convierte las cadenas a objetos Moment
      const momentA = moment(dateStrA, "YYYY-MM-DD HH:mm:ss");
      const momentB = moment(dateStrB, "YYYY-MM-DD HH:mm:ss");

      // Calcula la diferencia en segundos
      const segundos = momentB.diff(momentA, "seconds");
      // console.log("LOS SEGUNDOS SON", segundos);
      return segundos;
    },

    //Dibujar grafico
    drawBox() {
      const canvas = this.$refs[this.myCanvas];
      if (canvas) {
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height); // Limpiar el canvas antes de redibujar
        console.log("SIZE DEL CANVAS DE LAS CAJAS", canvas.width);
        console.log("offsetWidth DEL CANVAS DE LAS CAJAS", canvas.offsetWidth);
        // context.fillStyle = "black";
        // context.fillRect(0, 0, 200, canvas.height); // posición (50, 50) y tamaño 200x200
        let lastFecha = null;
        let lastValue = null;
        let lastColor = null;
        let posX = 0;
        let diff = 0;
        let current_width = 0;

        this.rectangles = []; // Limpiar el array de rectángulos antes de redibujar
        const fechaActual = moment().toISOString();
        for (let index = 0; index < this.dataList.length; index++) {
          const element = this.dataList[index];
          if (index == 0) {
            lastColor = element.color;
            lastValue = element.value;
            const lastFechaSinFormato = this.filtroAsociado.valorFechas.inicio;
            lastFecha = moment(lastFechaSinFormato, "YYYY-MM-DD HH:mm:ss").toISOString();
            console.log("LA PRIMERA FECHA ES", lastFecha);
            console.log(element.read_at);
            if (moment(element.read_at).isAfter(lastFecha)) {
              diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, element.read_at);
              current_width = (this.canvasWidth * diff) / this.timeDifferenceInSeconds;
              context.fillStyle = "#ffffff";
              context.fillRect(posX, 0, current_width, canvas.height);
              posX += current_width;
              lastFecha = element.read_at;
            }
            // diff = this.diferenciaEntreFechaHorasEnSegundos(element.read_at, this.filtroAsociado.valorFechas.inicio);
            continue;
          }
          console.log("LA FECHA EN EL INDICE", index, " ES ", element.read_at);
          let fechaRectanguloInicio = null;
          diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, element.read_at);
          fechaRectanguloInicio = element.read_at;

          if (index == this.dataList.length - 1) {
            let ultimaFecha = moment(this.filtroAsociado.valorFechas.fin, "YYYY-MM-DD HH:mm:ss").toISOString();
            if (moment(ultimaFecha).isAfter(fechaActual)) {
              ultimaFecha = fechaActual;
            }
            diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, ultimaFecha);
            // fechaRectanguloInicio = this.filtroAsociado.valorFechas.fin;
            fechaRectanguloInicio = ultimaFecha;
          }
          current_width = (this.canvasWidth * diff) / this.timeDifferenceInSeconds;
          context.fillStyle = lastColor;
          context.fillRect(posX, 0, current_width, canvas.height); // posición (50, 50) y tamaño 200x200

          this.rectangles.push({
            x: posX,
            y: 0,
            width: current_width,
            height: canvas.height,
            color: lastColor,
            value: lastValue,
            fechaInicio: lastFecha,
            fechaFin: fechaRectanguloInicio,
            diferenciaEnSegundos: diff,
          });

          posX += current_width;
          lastFecha = element.read_at;
          lastColor = element.color;
          lastValue = element.value;
          // }
          // if (index == 2) return;
        }
      }
    },
    //Dibujar horas
    drawLabels() {
      const scaleFactor = 2; // Factor de escala para mejorar la resolución del canvas
      const canvasDatos = this.$refs[this.myCanvas];
      const canvasLabels = this.$refs.myCanvasLabels;
      // Configuración del canvas para alta resolución
      canvasLabels.width = canvasDatos.width * scaleFactor;
      canvasLabels.height = canvasDatos.height * 4 * scaleFactor;

      const context = canvasLabels.getContext("2d");
      context.scale(scaleFactor, scaleFactor);
      context.clearRect(0, 0, canvasLabels.width, canvasLabels.height); // Limpiar el canvas de etiquetas antes de redibujar
      if (this.dataList.length == 0) return;
      if (!this.filtroAsociado || Object.keys(this.filtroAsociado).length === 0) return;

      console.log("offsetWidth DEL CANVAS DE LOS LABELS", canvasLabels.offsetWidth);

      console.log("SIZE DEL CANVAS DE LAS etiquetas", canvasLabels.width);
      if (canvasLabels) {
        // Configuración de la fuente
        const fontSize = this.scadaDimensions.height * 0.01 + 3; // Ajusta el tamaño de la fuente según la dimensión del SCADA
        context.font = `${fontSize}px Arial`;
        context.fillStyle = "black";
        const angle = (-90 * Math.PI) / 180; // Ángulo de inclinación en radianes

        // Generar etiquetas de fecha distribuidas uniformemente
        const numLabels = (canvasLabels.width / scaleFactor) * 0.02; // Ajusta el número de etiquetas según el tamaño escalado
        const labels = this.generateUniformDateLabels(
          this.filtroAsociado.valorFechas.inicio,
          this.filtroAsociado.valorFechas.fin,
          numLabels
        );

        // Calcular el ancho de cada intervalo entre etiquetas
        const interval = canvasLabels.width / scaleFactor / (numLabels - 1);

        // Dibujar cada etiqueta con el ángulo y posición calculados
        labels.forEach((label, index) => {
          const adjustedPosX = interval * index;
          const ZERO = fontSize * 5; // Ajuste para la posición Y de las etiquetas

          if (adjustedPosX >= 0 && adjustedPosX <= this.canvasWidth) {
            this.drawRotatedText(
              context,
              moment(label).format("YYYY-MM-DD HH:mm:ss"),
              adjustedPosX,
              ZERO,
              angle,
              fontSize
            );
          }
        });
      }
    },

    //dibujar en directo
    drawLive() {
      const canvas = this.$refs[this.myCanvas];
      if (canvas) {
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height); // Limpiar el canvas antes de redibujar
        this.client.on("message", (topic, message) => {
          if ( this.input.customized.filterType=="MQTT" &&  this.input.customized.mqtt == topic ) {
            //cambiar el if por otro en el que pregunte si el atributo del default es mqtt
            this.rectangles = [];
            const lastValue = parseInt(message.toString());
            const lastColor = this.generarColor(parseInt(message.toString()));
            const lastFecha = moment.tz("Europe/Madrid").format("YYYY-MM-DD HH:mm:ss");

            this.mqttVal = lastValue;

            context.fillStyle = lastColor;
            context.fillRect(0, 0, canvas.width, canvas.height); // posición (50, 50) y tamaño 200x200
            this.rectangles.push({
              x: 0,
              y: 0,
              width: canvas.width,
              height: canvas.height,
              color: lastColor,
              value: lastValue,
              fechaInicio: lastFecha,
              fechaFin: lastFecha,
              diferenciaEnSegundos: 0,
            });
          }
        });
      }
    },

    //Dibujar leyenda en directo
    drawLiveLegend() {
      const scaleFactor = 2; // Factor de escala para mejorar la resolución del canvas
      const canvasDatos = this.$refs[this.myCanvas];
      const canvas = this.$refs.myCanvasLabels;
      // Configuración del canvas para alta resolución
      canvas.width = canvasDatos.width * scaleFactor;
      canvas.height = canvasDatos.height * 4 * scaleFactor;

      // Aplicar escala al contexto del canvas
      const context = canvas.getContext("2d");
      context.save(); // Guardar el estado del contexto
      context.scale(scaleFactor, scaleFactor);

      // Limpiar el canvas antes de redibujar
      context.clearRect(0, 0, canvas.width / scaleFactor, canvas.height / scaleFactor);

      const x = 0; // Posición horizontal inicial
      const y = canvas.height / (7.5 * scaleFactor); // Posición vertical base para centrar texto con respecto al cuadrado
      const squareSize = canvas.width / (scaleFactor * 20); // Tamaño del cuadrado en función del ancho del canvas
      const textMargin = canvas.width / (scaleFactor * 50); // Margen entre el cuadrado y el texto
      const fontSize = canvas.width / (scaleFactor * 65); // Tamaño de la fuente función del tamaño del canvas

      context.font = `${fontSize}px Arial`;
      const estado = this.input.customized.estados.filter((estado) => estado.valor == this.mqttVal)[0];

      //creacion del cuadrado con el color del estado
      context.fillStyle = estado.color;
      context.fillRect(x, y - squareSize / 2, squareSize, squareSize);

      // Dibujar el texto
      context.fillStyle = "#000"; // Color del texto
      context.textAlign = "left"; // Alineación del texto
      context.textBaseline = "middle"; // Baseline del texto

      context.fillText(estado.nombre, x + squareSize + textMargin, y);
      context.restore();
    },

    generateUniformDateLabels(startDateStr, endDateStr, numLabels) {
      const startDate = moment(startDateStr, "YYYY-MM-DD HH:mm:ss");
      const endDate = moment(endDateStr, "YYYY-MM-DD HH:mm:ss");
      const totalDuration = endDate.diff(startDate, "seconds");

      const labels = [];
      for (let i = 0; i < numLabels; i++) {
        const currentMoment = startDate.clone().add((totalDuration / (numLabels - 1)) * i, "seconds");
        labels.push(currentMoment.toISOString()); // Usa toISOString para asegurar formato consistente
      }
      return labels;
    },

    drawRotatedText(context, text, x, y, angle, fontSize) {
      context.save(); // Guarda el estado actual del contexto
      context.font = `${fontSize}px Arial`;
      context.translate(x, y); // Mueve el origen de coordenadas
      context.rotate(angle); // Rota el contexto
      context.textAlign = "center"; // Alinea el texto al centro
      context.textBaseline = "middle"; // Alinea el texto verticalmente en el medio
      context.fillText(text, 0, 0); // Dibuja el texto
      context.restore(); // Restaura el estado original del contexto
    },

    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.updateCanvasSize();
    },
  },
  mounted() {
    console.log("MONTADO GRAFICO V1!!", this.input)
    this.updateCanvasSize()
    // this.createConnection();
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
    //desconectar del broker
    // this.destroyConnection();
  },
};
</script>

<style scoped>
.completo {
  display: flex;
  flex-direction: column; /* Coloca los elementos uno debajo del otro */
  height: 100%;
  width: 100%;
}

.canvas-data,
.canvas-labels {
  display: block; /* Asegura que cada canvas esté en su propia línea */
  width: 100%; /* Ajusta el ancho al 100% del contenedor */
  margin: 0; /* Elimina cualquier margen */
  padding: 0; /* Elimina cualquier padding */
}

.canvas-labels {
  margin-top: 0; /* Asegura que no haya margen superior */
}

.info-div {
  position: absolute;
  width: 30%; /* Ajusta el ancho según tus necesidades */
  z-index: 9999; /* Div de información, por encima de los otros canvases y el div */
  display: none; /* Oculta el div de información por defecto */
  pointer-events: none; /* Evita que el div interfiera con la interacción con otros elementos */
  background: rgba(154, 42, 42, 0.8); /* Fondo con opacidad */
  border: 1px solid #ddd; /* Borde gris claro */
  padding: 5px; /* Espaciado interno reducido */
  border-radius: 5px; /* Esquinas redondeadas */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Sombra sutil */
  font-size: 12px; /* Tamaño de fuente más pequeño */
  color: #fff; /* Color del texto blanco para mejor contraste */
}
.info-content {
  line-height: 0.8; /* Controla la altura de la línea */
}

.info-content span {
  margin: 0; /* Asegura que no haya margen entre los elementos */
  display: block; /* Asegura que cada span esté en su propia línea */
}

.info-label,
.info-value {
  margin: 0;
  padding: 0;
  color: #fff; /* Valor en color blanco para mejor visibilidad */
  display: inline-block; /* Mantiene el label y el valor en la misma línea */
}

.download-button {
  font-size: 2vw; /* Ajusta la fuente a 2% del ancho de la pantalla */
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
